module.exports = __webpack_public_path__ + "static/media/productValues1.f3d9234c.svg";